module.exports = __webpack_public_path__ + "static/media/nav-refunds-red.33b30fc3.svg";